import React, {Component} from "react"
import MobileDetect from "mobile-detect"

import Button from "@irati/ui/src/Button"
import Loading from "@irati/ui/src/Loading"
import {FormattedMessage} from "@irati/utils/lang"
import {textMeInstructions} from "@irati/medical/services/medical"
import medicalTracking from "@irati-tracking/medical"
import {DeepLinkingUrls} from "@irati/medical/enums"
import isMobileDevice from "@irati/utils/mobile"

import SentText from "./SentText"
import LoadingWrapper from "./LoadingWrapper"

interface Props {
  isFull?: boolean
  phoneNumber: string
  activationCode: string
  trackingLocation: string
}

interface State {
  load: Promise<any> | null
  isSent: boolean
}

class TextMeInstructions extends Component<Props, State> {
  static defaultProps = {
    isFull: false
  }

  state = {
    load: null,
    isSent: false
  }

  sendSMS = () => {
    const {activationCode, trackingLocation} = this.props
    medicalTracking.textRequested(activationCode, trackingLocation)
    const load = textMeInstructions().then(() => {
      this.setState({isSent: true})
    })
    this.setState({load})
  }

  openApp = () => {
    const {activationCode, trackingLocation} = this.props
    const detect = new MobileDetect(window.navigator.userAgent)
    medicalTracking.launchApp(activationCode, trackingLocation)

    if (detect.os() === "iOS") {
      window.location.assign(DeepLinkingUrls.LINK_TO_STORE_PERKBOX_MEDICAL_IOS)
    } else {
      window.location.assign(DeepLinkingUrls.LINK_TO_STORE_PERKBOX_MEDICAL_ANDROID)
    }
  }

  render() {
    const {phoneNumber, isFull} = this.props
    const {load, isSent} = this.state
    const lastThreeDigits = phoneNumber.substr(phoneNumber.length - 3)

    if (isMobileDevice()) {
      return (
        <Button primary large full onClick={this.openApp}>
          <FormattedMessage id="medical.global.buttons.openApp" />
        </Button>
      )
    }
    if (!phoneNumber) {
      return <FormattedMessage id="medical.textMeInstructions.noPhoneNumber" />
    }
    return (
      <>
        <Button load={load} primary large full={isFull} onClick={this.sendSMS}>
          <FormattedMessage id="medical.global.buttons.instructions" />
        </Button>
        {isSent && <SentText lastThreeDigits={lastThreeDigits} />}
        <LoadingWrapper>
          <Loading load={load} useLoader={false} />
        </LoadingWrapper>
      </>
    )
  }
}

export default TextMeInstructions
